// gatsby-browser.js
import "./src/styles/global.css";
import "./src/styles/print.css";
import React from "react";
import RootProviders from "./src/context/RootProviders";

export const onClientEntry = () => {
  window.addEventListener("unhandledrejection", (event) => {
    const message = String(event.reason || "");

    if (
      message.includes("ChunkLoadError") ||
      message.includes("Loading chunk")
    ) {
      console.warn("Chunk load error detected, reloading...");
      window.location.reload();
    }
  });
};

export const wrapRootElement = ({ element }) => (
  <RootProviders>{element}</RootProviders>
);